export * from './copy-content-trigger-standalone-farol'
